exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-input-number--mini{width:100px;line-height:38px;height:40px}.el-input--mini .el-input__inner{color:#ff4500!important;font-size:18px!important;font-weight:700!important}.el-select-dropdown{width:auto!important;box-sizing:border-box}", ""]);

// exports
